import { Component } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { NavParams} from 'ionic-angular';
import { AppState } from '../../../app/app.global';
//import {MachineType} from "../../../providers/util/machine";
@Component({
  selector: 'page_camera',
  templateUrl: 'camera.html'
})
export class CameraPage {
	constructor (public params: NavParams,public global: AppState
								,private camera: Camera) {

	}

	takePhoto(){
			const options: CameraOptions = {
			  quality: 100,
			  destinationType: this.camera.DestinationType.DATA_URL,
			  encodingType: this.camera.EncodingType.JPEG,
			  mediaType: this.camera.MediaType.PICTURE
			}
			this.camera.getPicture(options).then((imageData) => {
			 	//let base64Image = 'data:image/jpeg;base64,' + imageData;
			}, (err) => {

			});
	}




}



// WEBPACK FOOTER //
// ./src/pages/test/camera/camera.ts